'use client';

import React from 'react';
import { CircleCheck, Rocket } from 'lucide-react';
import Image from 'next/image';
import { Button } from '@/components/ui/Button';
import Link from 'next/link';

const OfferSection = () => {
  return (
    <section id="offer" className="py-16 px-4 md:px-8 bg-primary-50 scroll-mt-12">
      <div className="max-w-xl md:max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-primary font-funnel mb-6">
          Inizia <span className="text-accent">gratis</span>, senza vincoli
        </h2>
        <p className="text-lg text-gray-600 mb-12">
          Entra nel programma di anteprima e sarai tra i primi professionisti in Italia a usare la
          nostra AI legale.
          <br />
          <strong>Zero costi, zero impegni</strong>: al termine della prova, ti riserveremo
          un’offerta esclusiva per continuare.
        </p>
        <div className="relative my-12 flex flex-col md:flex-row text-text-base overflow-hidden bg-white rounded-xl border-3 border-accent shadow-accent-500/50 shadow-md hover:shadow-lg transition duration-200">
          <div className="relative flex-1 min-h-64">
            <Image
              src="/images/offer/thumb-up.webp"
              alt="Visualizzazione di funzionalità per la creazione di booking e l'interazione con form e post"
              fill
              className="object-cover"
            />
          </div>
          <div className="flex-2 rounded-lg p-8 text-left">
            <h3 className="text-md md:text-lg text-neutral-700 font-bold mb-6">
              L&apos;offerta esclusiva per chi entra ora:
            </h3>
            <ul
              role="list"
              className="flex flex-wrap gap-x-6 gap-y-3 flex-col items-start text-left"
            >
              <li className="flex items-top flex-row gap-x-3">
                <CircleCheck className="w-5 h-5 min-w-5 mt-1 text-accent" />
                <div className="text-md md:text-lg text-neutral-700">
                  <strong>Gratuito</strong> per le prime due settimane.
                </div>
              </li>
              <li className="flex items-top flex-row gap-x-3">
                <CircleCheck className="w-5 h-5 min-w-5 mt-1 text-accent" />
                <div className="text-md md:text-lg text-neutral-700">
                  <strong>Sconto Early-Bird</strong> sulla tariffa di lancio.
                </div>
              </li>
              <li className="flex items-top flex-row gap-x-3">
                <CircleCheck className="w-5 h-5 min-w-5 mt-1 text-accent" />
                <div className="text-md md:text-lg text-neutral-700">
                  <strong>Nessuna carta richiesta</strong>, la registrazione è senza impegno.
                </div>
              </li>
              <li className="flex items-top flex-row gap-x-3">
                <CircleCheck className="w-5 h-5 min-w-5 mt-1 text-accent" />
                <div className="text-md md:text-lg text-neutral-700">
                  <strong>Corsia preferenziale</strong> per nuove funzionalità e assistenza.
                </div>
              </li>
            </ul>
          </div>
          <div className="absolute top-0 right-0 px-2 py-0.5 rounded-bl-lg bg-accent text-white text-sm font-medium">
            OFFERTA LIMITATA
          </div>
        </div>
        <div>
          <Button asChild size="xl" variant="accent-default">
            <Link href={process.env.NEXT_PUBLIC_APP_URL + '/signup'}>
              <Rocket className="w-6 h-6 mr-3" />
              Provalo gratis ora
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default OfferSection;
